// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedAcquireScanModeSector_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.9621 11.5757C18.5959 8.05401 15.6186 5.3083 12 5.3083C8.38142 5.3083 5.40413 8.05401 5.03788 11.5757H1V13.0757H5.04158C5.42375 16.5807 8.39334 19.3083 12 19.3083C15.6067 19.3083 18.5762 16.5807 18.9584 13.0757H23V11.5757H18.9621ZM17.4469 13.0757C17.0735 15.75 14.7771 17.8083 12 17.8083C9.22285 17.8083 6.92645 15.75 6.55311 13.0757H17.4469ZM17.4516 11.5757H6.54837C6.90657 8.88448 9.21083 6.8083 12 6.8083C14.7892 6.8083 17.0934 8.88448 17.4516 11.5757Z" class="svg-bg"/>
  <path d="M3.69141 19.5563L19.2478 4L20.3084 5.06066L4.75207 20.617L3.69141 19.5563Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedAcquireScanModeSector is a generated icon component.
 */
let IconMedAcquireScanModeSector = IconMedAcquireScanModeSector_1 = class IconMedAcquireScanModeSector extends IconBaseElement {
    render() {
        return html `${IconMedAcquireScanModeSector_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedAcquireScanModeSector.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedAcquireScanModeSector = IconMedAcquireScanModeSector_1 = __decorate([
    customElement('zui-icon-med-acquire-scan-mode-sector')
], IconMedAcquireScanModeSector);
export { IconMedAcquireScanModeSector };
